import React from "react";
import _ from "lodash";
const AssetsUtil = require("../AssetsUtil");

export interface TopBarInfoProps {
	styles: {
		blurbContent: string;
		blurbQ: string;
		blurbContentV: string;
	};
	iconName: string;
	type: "unlock";
	extraInfo?: string;
}

export const TopBarInfo: React.FC<TopBarInfoProps> = ({
	styles,
	iconName,
	type,
	extraInfo,
}) => {
	if (type === "unlock") {
		return (
			<div className={styles.blurbContentV}>
				<div>{`You unlocked the ${extraInfo}!`}</div>
				<div>
					{`Click the`}
					<span>
						<img
							className={styles.blurbQ}
							src={AssetsUtil.getButton(iconName)}
						/>
					</span>
					{`to visit the BA ${_.capitalize(extraInfo)}.`}
				</div>
			</div>
		);
	}
	return null;
};
